<template>
  <div class="app-container">
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="課堂編號/確認完課時間" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
          <br>
          <span>{{ scope.row.confirmFinishedTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="課程" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.courseTitle }}</span>
          <br>
          <span>{{ scope.row.courseNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="類型/上課時間" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.courseTypeName }}</span>
          <br>
          <span>{{ scope.row.lessonTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="學生" width="100">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="studentLists(scope.row.number, scope.row.courseTitle, scope.row.students)">點我查看</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="老師" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.teacherName }}</span>
          <br>
          <span>{{ scope.row.teacherNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="單堂應收點數" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.coursePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="總應收點數" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.lessonTotalPrice }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    <StudentDialog :dialog-student-visible-prop="dialogStudentVisible" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination'
import EventResource from '@/api/event'
import StudentDialog from '@/views/billings/finish/student'
const eventResource = new EventResource()
export default {
  name: 'EventList',
  components: { Pagination, StudentDialog },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        lessonTimeStatus: 'finished'
      },
      dialogStudentVisible: false,
      currentStudentListLessonNumber: '',
      currentStudentListCourseTitle: '',
      currentStudentListData: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await eventResource.getLessonTimeList(this.listQuery)
      console.log(data)
      this.list = data.items
      this.total = data.total
      this.listLoading = false
    },
    handleFilter() {
      this.getList()
    },
    studentLists(lessonNumber, courseTitle, students) {
      this.currentStudentListLessonNumber = lessonNumber
      this.currentStudentListCourseTitle = courseTitle
      this.currentStudentListData = students
      this.dialogStudentVisible = true
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.el-table {
  position: inherit!important;
}
</style>
